import * as globals from 'src/app/globals';
import { Component, OnInit, HostListener, AfterViewInit, OnDestroy, ViewContainerRef, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Location as AngularLocation } from '@angular/common';
import { DataService } from 'src/app/services/data.service';
import { Issue, NextcloudFile, Notification } from 'src/app/classes';
import { Subscription } from 'rxjs';
import { WebsocketService } from 'src/app/services/websocket.service';
import { OnlyofficeDialogComponent, OnlyofficeDialogComponentData } from '../../../lib/nextcloud/components/dialog/onlyoffice-dialog/onlyoffice-dialog.component';
import { QuickAssistComponent, WistaAMSAssistCallbacks } from '../../dialog-components/quick-assist/quick-assist.component';
import { SelectContractDialogComponent } from '../../../lib/contract/components/dialog/select-contract-dialog/select-contract-dialog.component';
import { SelectIncidentDialogComponent } from '../../../lib/issue/components/dialog/select-incident-dialog/select-incident-dialog.component';
import { ConfirmDialogComponent, ConfirmDialogComponentData } from '../../../lib/shared/components/dialog/confirm-dialog/confirm-dialog.component';
import { SelectUserComponent } from '../../dialog-components/select-user/select-user.component';
import { NotificationDialogComponent } from '../../dialog-components/notification-dialog/notification-dialog.component';
import { NotificationDetailsDialogComponent } from '../../notification-details-dialog/notification-details-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { SelectCustomerDialogComponent } from 'src/app/lib/customer/components/dialog/select-customer-dialog/select-customer-dialog.component';
import { ISSUE_PROVIDER_SERVICE, ISSUE_TRANSACTION_PROVIDER_SERVICE } from 'src/app/lib/issue/interfaces';
import { NavbarComponentService } from './navbar-component.service';
import { executeIssueTransaction, SpecialIssueTransactionRole } from 'src/app/lib/issue/globals';
import { IssueTransactionService } from 'src/app/lib/issue/services/issue-transaction.service';
import { showAnimation } from 'src/animations';
import { SessionService } from 'src/app/lib/shared/services/session.service';
import { User } from 'src/app/lib/user/classes';
import { SelectIssueDialogComponent } from 'src/app/lib/issue/components/dialog/select-issue-dialog/select-issue-dialog.component';
import { SelectChangeDialogComponent } from 'src/app/lib/issue/components/dialog/select-change-dialog/select-change-dialog.component';
import { CreateCustomerDialogComponent } from 'src/app/lib/customer/components/dialog/create-customer-dialog/create-customer-dialog.component';
import { IssueTypes } from 'src/app/lib/shared/globals';
import { IssueService } from 'src/app/lib/issue/services/issue.service';
import { filter, switchMap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Contract } from 'src/app/lib/contract/classes';
import { CreateContractDialogComponent } from 'src/app/lib/contract/components/dialog/create-contract-dialog/create-contract-dialog.component';
import { SelectContactDialogComponent } from 'src/app/lib/customer/components/dialog/select-contact-dialog/select-contact-dialog.component';
import { Contact, Customer } from 'src/app/lib/customer/classes';
import { CreateContactDialogComponent } from 'src/app/lib/customer/components/dialog/create-contact-dialog/create-contact-dialog.component';
import { SelectLocationDialogComponent } from 'src/app/lib/location/components/dialog/select-location-dialog/select-location-dialog.component';
import { Location } from 'src/app/lib/location/classes';
import { CreateLocationDialogComponent } from 'src/app/lib/location/components/dialog/create-location-dialog/create-location-dialog.component';
import { SelectOfferDialogComponent } from 'src/app/lib/offer/components/dialog/select-offer-dialog/select-offer-dialog.component';
import { CreateOfferComponent } from 'src/app/lib/offer/components/dialog/create-offer/create-offer.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TokenService } from 'src/app/lib/shared/services/token.service';
import { IssueTransaction } from 'src/app/lib/issue/classes';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  animations: [showAnimation],
  providers: [
    { provide: ISSUE_PROVIDER_SERVICE, useClass: NavbarComponentService },
    { provide: ISSUE_TRANSACTION_PROVIDER_SERVICE, useExisting: ISSUE_PROVIDER_SERVICE }
  ]
})
export class NavbarComponent implements OnInit, OnDestroy, AfterViewInit {

  loaderDisplayHeight: number = 0;
  progress: number = 35;
  _progressAim: number = 50;
  progressInterval: number = null;

  hasProfilePicture: boolean = false;
  profilePictureData: string = null;
  userInitials: string = null;
  username: string = null;

  rightsMap = {
    "edit_datasets": false,
    "use_report_system": false,
    "use_shop": false,
    "update_own_settings": false,
    "customer_navbar_option": false,
    "issue_navbar_option": false,
    "update_issues": false,
    "location_navbar_option": false,
    "overwrite_control_slip": false
  };

  notificationCounter: number = 0;

  navbarView: number = navbarViewOptions.Full;

  socketState: SocketConnectionState = socketConnectionStates.NoConnection;

  counterShouldContainErrorMessages: boolean = false;

  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject(ISSUE_PROVIDER_SERVICE) public navbarComponentService: NavbarComponentService,
    private _issueTransactionService: IssueTransactionService,
    private _issueService: IssueService,
    private _router: Router,
    private _location: AngularLocation,
    public sessionService: SessionService,
    private _snackBar: MatSnackBar,
    private _dialog: MatDialog,
    private _socketService: WebsocketService,
    private _viewContainerRef: ViewContainerRef,
    private _dataService: DataService,
    private _httpClient: HttpClient,
    private _tokenService: TokenService
  ) {
    if (!_dataService.unseenNotificationsLoaded) this._dataService.loadUnseenNotifications();
  }

  addOffer() {
    this._dialog.open(CreateOfferComponent, {
      panelClass: 'no-padding-dialog-container'
    });
  }

  calculateNotificationCount() {
    var count = 0;
    if (this._dataService && Array.isArray(this._dataService.notifications)) count += this._dataService.notifications.filter(x => !x.notificationseen).length;
    this.notificationCounter = count;
  }

  exectueCreateIncidentTransaction() {
    this._issueTransactionService.getIssueTransactionBySpecialRole(SpecialIssueTransactionRole.CREATE_INCIDENT).pipe(switchMap((transaction: IssueTransaction) => executeIssueTransaction(this._issueTransactionService, transaction.guid, this._viewContainerRef, () => {
      this.navbarComponentService.provideEmptyIssue();
      this.navbarComponentService.setIssueType(IssueTypes.Incident);
    }))).toPromise();
  }

  executeCreateIssueTransaction() {
    this._issueTransactionService.getIssueTransactionBySpecialRole(SpecialIssueTransactionRole.CREATE_ISSUE).pipe(switchMap((transaction: IssueTransaction) => executeIssueTransaction(this._issueTransactionService, transaction.guid, this._viewContainerRef, () => {
      this.navbarComponentService.provideEmptyIssue();
      this.navbarComponentService.setIssueType(IssueTypes.Issue);
    }))).toPromise();
  }

  gotoStartpage = () => this._router.url.startsWith('/home')? location.reload(): this._router.navigate(['/home']);

  ngAfterViewInit() {
    this.validateView();
  }
  
  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit() {
    this._subscriptions.push(...[
      this.sessionService.user$.subscribe((user: User) => this.setUser(user)),
      this._socketService.connectionStarted.subscribe(() => this.socketState = socketConnectionStates.Success),
      this._socketService.internalNotificationReceived.subscribe(() => this.calculateNotificationCount())
    ]);
    this.initRights(true);
  }

  initRights = (soft: boolean = true) => {
    for (let index in this.rightsMap) this.sessionService.hasRight(index, soft).subscribe(result => this.rightsMap[index] = result);
  }

  logout = () => this.sessionService.logout();
  navigateToAllStocks = () => window.open(locations.AllStocks);
  navigateToWistaIncrease = () => window.open(locations.WistaIncrease);
  navigateToWistaDecrease = () => window.open(locations.WistaDecrease);
  navigateToSonyIncrease = () => window.open(locations.SonyIncrease);
  navigateToSonyDecrease = () => window.open(locations.SonyDecrease);
  navigateToWistaServiceReview = () => window.open(locations.WistaServiceReview);
  navigateToWistaTicketReview = () => window.open(locations.WistaTicketReview);
  navigateToDocumentation = () => window.open("https://ams.campus-netz.services/swagger");
  navigateToGeneralSetting = () => this._router.navigate(["/settings"]);
  navigateToProcessDoc = () => window.open(locations.ProcessDoc);
  navigateToAdminDoc = () => window.open(locations.AdminDoc);

  @HostListener('window:resize', ['$event'])
  onResize = () => this.validateView();

  openStockList() {
    this._dialog.open(OnlyofficeDialogComponent, {
      panelClass: "no-padding-dialog-container",
      autoFocus: false,
      data: {
        file: {
          fileId: "262166",
          href: "/Lager/Lagerbuchungen%20Wista%20Version_3.0.xlsx"
        } as NextcloudFile
      } as OnlyofficeDialogComponentData
    });
  }

  openQuickAssist() {
    this._subscriptions.push(this._dialog.open(QuickAssistComponent, {
      panelClass: "no-padding-dialog-container",
      autoFocus: false
    }).afterClosed().subscribe((action: number) => {
      if (action) {
        switch (action) {

          case WistaAMSAssistCallbacks.CreateContactperson:
            this.quickCreateContactperson();
            break;

          case WistaAMSAssistCallbacks.CreateCustomer:
            this.quickCreateCustomer();
            break;

          case WistaAMSAssistCallbacks.CreateIncidentTransaction:
            this.exectueCreateIncidentTransaction();
            break;

          case WistaAMSAssistCallbacks.CreateIssue:
            this.executeCreateIssueTransaction();
            break;

          case WistaAMSAssistCallbacks.CreateContract:
            this.quickCreateContract();
            break;

          case WistaAMSAssistCallbacks.CreateLocation:
            this.quickCreateLocation();
            break;

          case WistaAMSAssistCallbacks.CreateOffer:
            this.quickCreateOffer();
            break;

        }
      }
    }));
  }

  quickCreateContactperson() {
    this._dialog.open(CreateContactDialogComponent, {
      panelClass: "no-padding-dialog-container",
      autoFocus: false
    });
  }

  quickCreateCustomer() {
    this._dialog.open(CreateCustomerDialogComponent, {
      panelClass: "no-padding-dialog-container",
      autoFocus: false
    });
  }
  /**
   * the method opens the quick assist and enables users to create new contracts
   */
  quickCreateContract() {
    this._dialog.open(CreateContractDialogComponent, {
      panelClass: "no-padding-dialog-container",
      autoFocus: false
    });
  }
  /**
   * the method opens the quick assist and enables users to create new contracts
   */
  quickCreateLocation() {
    this._dialog.open(CreateLocationDialogComponent, {
      panelClass: "no-padding-dialog-container",
      autoFocus: false
    });
  }
  /**
   * the method opens the quick assist and enables users to create new offers
   */
  quickCreateOffer() {
    this._dialog.open(CreateOfferComponent, {
      panelClass: "no-padding-dialog-container",
      autoFocus: false
    });
  }
  /**
   * the method opens the select change dialog
   */
  selectChangeForEdit() {
    this._dialog.open(SelectChangeDialogComponent, {
      panelClass: "no-padding-dialog-container",
      autoFocus: false
    }).afterClosed().subscribe((result: Issue) => {
      if (result) this._router.navigate(['/issue-details', result.issueid]);
    });
  }
  /**
   * the method opens the select customer dialog
   */
  selectCustomerForEdit() {
    this._dialog.open(SelectCustomerDialogComponent, {
      panelClass: "no-padding-dialog-container",
      autoFocus: false
    }).afterClosed().subscribe((result: Customer) => {
      if (result) this._router.navigate(["/customer-details", result.customerid]);
    });
  }
  /**
   * the method opens the select contactperson dialog
   */
  selectContactpersonForEdit() {
    this._dialog.open(SelectContactDialogComponent, {
      panelClass: "no-padding-dialog-container",
      autoFocus: false
    }).afterClosed().subscribe((result: Contact) => {
      if (result) this._router.navigate(["/contact-details", result.contactpersid]);
    });
  }
  /**
   * the method opens the select contract dialog
   */
  selectContractForEdit() {
    this._dialog.open(SelectContractDialogComponent, {
      panelClass: "no-padding-dialog-container",
      autoFocus: false
    }).afterClosed().subscribe((result: Contract) => {
      if (result) this._router.navigate(["/contract-details", result.contractid]);
    });
  }
  /**
   * the method opens the select incident dialog
   */
  selectIncidentForEdit() {
    this._dialog.open(SelectIncidentDialogComponent, {
      panelClass: "no-padding-dialog-container",
      autoFocus: false
    }).afterClosed().subscribe((result: Issue) => {
      if (result) this._router.navigate(['/issue-details', result.issueid]);
    });
  }
  /**
   * the method opens the select issue dialog
   */
  selectIssueForEdit() {
    this._dialog.open(SelectIssueDialogComponent, {
      panelClass: "no-padding-dialog-container",
      autoFocus: false
    }).afterClosed().subscribe((result: Issue) => {
      if (result) this._router.navigate(['/issue-details', result.issueid]);
    });
  }
  /**
   * the method opens the select issue dialog to overwrite a conbtrol slip
   */
  selectIssueToOverwriteControlSlip() {
    let callback = (issue: Issue) => {
      this._dialog.open(ConfirmDialogComponent, {
        data: {
          "checkValue": issue.issuenumber.toString(),
          "headline": "Standardlaufzettel überschreiben",
          "text": "Sind Sie sicher, dass sie für den Vorgang einen Standardlaufzettel anlegen/überschreiben möchten? Achtung: bestehende Standardlaufzettel werden überschrieben!",
          "hasSecondButton": false
        } as ConfirmDialogComponentData
      })
        .afterClosed().pipe(filter(x => x ? true : false), switchMap(() => this._issueService.overwriteControlSlip(issue.issueid)))
        .subscribe({
          next: () => this._snackBar.open(`Der Laufzettel des Vorgangs ${issue.issuenumber} wurde erfolgreich überschrieben`, 'Ok', {
            duration: 2000
          }),
          error: () => this._snackBar.open(`Der Laufzettel des Vorgangs ${issue.issuenumber} konnte nicht überschrieben werden`, 'Fehler', {
            duration: 2000
          })
        })
    }
    const dialogRef = this._dialog.open(SelectIssueDialogComponent, {
      panelClass: "no-padding-dialog-container",
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe((result: Issue) => {
      if (result) callback(result);
    });
  }
  /**
   * the method opens the select a location dialog
   */
  selectLocationForEdit() {
    const dialogRef = this._dialog.open(SelectLocationDialogComponent, {
      panelClass: "no-padding-dialog-container",
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe((result: Location) => {
      if (result) this._router.navigate(["/location-details", result.locationid]);
    });
  }
  /**
   * the method opens the select offer dialog
   */
  selectOfferForEdit() {
    this._dialog.open(SelectOfferDialogComponent, {
      panelClass: "no-padding-dialog-container",
      autoFocus: false
    }).afterClosed().subscribe((result) => {
      if (result) this._router.navigate(["/offer-details", result.offerid]);
    });
  }
  /**
   * the method opens the select user component and navigates to the edit dashboard view
   */
  selectUserAndEditDashboard() {
    const dialogRef = this._dialog.open(SelectUserComponent, {
      panelClass: "no-padding-dialog-container",
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe((result: User) => {
      if (result) this._router.navigate(["/foreign-dashboard"], {
        queryParams: {
          "username": result.userName
        }
      });
    });
  }

  setProgress(progress: number) {
    if (this.progressInterval) clearInterval(this.progressInterval);
    this.progress = 0;
    this._progressAim = progress;
    this.progressInterval = window.setInterval(() => {
      this._setProgressStep();
    }, 10);
  }

  _setProgressStep() {
    if (this._progressAim == this.progress) {
      clearInterval(this.progressInterval);
      this._progressAim = null;
      this.progressInterval = null;
    }
    else {
      this.progress++;
    }
    if (this.progress == 100) {
      setTimeout(() => this.loaderDisplayHeight = 0, 1000);
    } else {
      this.loaderDisplayHeight = 3;
    }
  }

  setUser(user: User) {
    if (user.initials) this.userInitials = user.initials;
    else if (user.userName) {
      this.userInitials = user.userName.substr(0, 3);
    }
    else {
      this.userInitials = "UNK";
    }
    if (user.userName) this.username = user.userName;
    else this.username = "unknown";
    if (user.profilePicture && user.profilePictureMediaType) {
      this.hasProfilePicture = true;
      this.profilePictureData = "data:" + user.profilePictureMediaType + ";base64," + user.profilePicture;
    } else {
      this.hasProfilePicture = false;
      this.profilePictureData = null;
    }
  }

  showNotifications() {
    this._dialog.open(NotificationDialogComponent, {
      panelClass: "no-padding-dialog-container",
      autoFocus: false
    }).afterClosed().subscribe((notification: Notification) => this.showNotificationDetails(notification));
  }

  showNotificationDetails(notification: Notification) {
    if (notification) {
      this._dialog.open(NotificationDetailsDialogComponent, {
        panelClass: "no-padding-dialog-container",
        autoFocus: false,
        data: notification
      }).afterClosed().subscribe((markAsUnseen: boolean) => {
        if (markAsUnseen) {
          let i = this._dataService.notifications.findIndex(x => x.notificationid == notification.notificationid);
          if (i > -1) this._dataService.notifications[i].notificationseen = null;
          else {
            notification.notificationseen = null;
            this._dataService.notifications.push(notification);
          }
          this._dataService.notificationsChangedAnchor.next();
          this.showNotifications();
        } else {
          this.showNotifications();
        }
      });
    }
  }

  tryToggleAutoLogout(){
    if(this.rightsMap.edit_datasets) this.sessionService.autoLogoutDisabled = !this.sessionService.autoLogoutDisabled;
  }

  next = () => this._location.forward();
  previous = () => this._location.back();

  validateView() {
    let w = window.innerWidth;
    if (w >= 960) {
      this.navbarView = navbarViewOptions.Full;
    } else if (w < 370) {
      this.navbarView = navbarViewOptions.CollapseAllNavs;
    } else {
      this.navbarView = navbarViewOptions.CollapseNavitems;
    }
  }

}

const locations = {
  "AllStocks": "https://ams.campus-netz.services/reports/report/WISTA-AMS%20Reports/WISTA-Best%C3%A4nde_ALLE_oGruppe",
  "APIDocumentation": globals.serverLocation + "/swagger",
  "WistaIncrease": "https://ams.campus-netz.services/reports/report/WISTA-AMS%20Reports/WISTA-Best%C3%A4nde_Mehrungen_2020",
  "WistaDecrease": "https://ams.campus-netz.services/reports/report/WISTA-AMS%20Reports/WISTA-Minderungen_2020",
  "SonyIncrease": "https://ams.campus-netz.services/reports/report/WISTA-AMS%20Reports/SONY-Best%C3%A4nde_Mehrungen_2020",
  "SonyDecrease": "https://ams.campus-netz.services/reports/report/WISTA-AMS%20Reports/SONY-Minderungen_2020",
  "WistaServiceReview": "https://ams.campus-netz.services/reports/report/WISTA-AMS%20Reports/WISTA-Servicereview",
  "WistaTicketReview": "https://ams.campus-netz.services/reports/report/WISTA-AMS%20Reports/Tickets",
  "AdminDoc": "https://cloud.campus.team/index.php/apps/files/?dir=/Betriebsdokumentation&fileid=2833",
  "ProcessDoc": "https://cloud.campus.team/index.php/apps/files/?dir=/Prozesshandbuch&fileid=473"
}

const navbarViewOptions = {
  Full: 0,
  CollapseNavitems: 1,
  CollapseAllNavs: 2
}

const socketConnectionStates = {
  "NoConnection": { icon: "leak_remove", color: "lightgray", tooltip: "Keine Serververbindung" } as SocketConnectionState,
  "Success": { icon: "done", color: "linear-gradient(135deg, #74ca33, #80ffb9)", tooltip: "Serververbindung aktiv" } as SocketConnectionState,
  "Error": { icon: "clear", color: "red", tooltip: "Fehler Serververbindung" } as SocketConnectionState
}

class SocketConnectionState {
  icon: string;
  color: string;
  tooltip: string;
}